module.exports = __webpack_public_path__ + "img/bentoboxohnehintergrund.c2ace88b.png";